import React from 'react';
import ReactDOM from 'react-dom/client';
// 計測ライブラリ
import reportWebVitals from './reportWebVitals';
import App from './App';
// import Header from './Header';
// import Footer from './Footer';
// import { Helmet } from 'react-helmet';
// import HeaderFile from './header.htm';
// import FooterFile from './footer.htm';



/* ========================================================
eデパートと美流の設定箇所（変更可）
=========================================================*/
// 開発フラグ
const dev = false;



/* ========================================================
eデパートと美流の設定箇所（固定）
=========================================================*/
// 出力タイプ：e=e.デパート b=美流百貨
const type = process.env.REACT_APP_CALENDAR_TYPE;

let conf;
// 本番
if (type === "e") {
	conf = {
		"type": type,
		// 基準ディレクトリ
		"docroot": "/contents/inc/feature/cosmecalendar",
		"json": (dev == true) ? "/contents/inc/feature/cosmecalendar" : "https://biryuhyakkaweb.jp/feature/cosmecalendar",
		// "json": "/contents/inc/feature/cosmecalendar",
		// ヘッダの高さ
		// "headerheight": 60 + 44,
		"headerheight": 120 + 82,
		"cdn": "https://img.sogo-seibu.jp",
	};
	// 別ディレクトリ
} else if (type === "d") {
	conf = {
		"type": type,
		// 基準ディレクトリ
		"docroot": "/contents/inc/feature/cosmecalendart",
		"json": (dev == true) ? "/contents/inc/feature/cosmecalendart" : "https://biryuhyakkaweb.jp/feature/cosmecalendar",
		// "json": "/contents/inc/feature/cosmecalendar",
		// "headerheight": 60 + 44,
		"headerheight": 120 + 82,
		"cdn": "https://img.sogo-seibu.jp",
	};
	// 美流
} else if (type === "b") {
	conf = {
		"type": type,
		// 基準ディレクトリ
		"docroot": "/feature/cosmecalendar",
		"json": "/feature/cosmecalendar",
		// // ヘッダ
		// "header": <Header />,
		// // フッタ
		// "footer": <Footer />,
		// ヘッダの高さ
		"headerheight": 182,
		"cdn": "",
	};
}


// eデパの場合は開発時のみ、美流はマストで必要
const sscss = (dev || conf["type"] === "b")
	? <><meta name="viewport" content="width=device-width, initial-scale=1.0" /><link rel="stylesheet" type="text/css" href="https://img.sogo-seibu.jp/contents/inc/common/css/freearea_common.css" media="all" /><link rel="stylesheet" type="text/css" href="https://img.sogo-seibu.jp/contents/inc/common/css/cmsbrand_module.css" /></> : "";

if (dev) console.log(sscss);

// CSSの切り替え
const pgstyle = (conf["type"] === "e" || conf["type"] === "d")
	? conf["cdn"] + conf["docroot"] + "/static/css/style.css" : conf["docroot"] + "/static/css/style-biryu.css";

if (dev) console.log(conf["type"]);

// // 美流百貨のみヘッダ・フッタ追加
// if (conf["type"] === "b") {
// 	fetch(HeaderFile)
// 		.then(res => res.text())
// 		.then(text => document.querySelector('body').insertAdjacentHTML('afterbegin', text));
// 	fetch(FooterFile)
// 		.then(res => res.text())
// 		.then(text => document.querySelector('body').insertAdjacentHTML('beforeend', text));
// }


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<div>
		{/* {conf["type"] === "b" && <Helmet>
			<meta name="google-site-verification" content="IiG_Y2_mHCFZQufipzSR6qYgHEuanIQLVCIth_GxUBc" />
			<meta charset="utf-8" />
			<title>★ページのタイトル</title>
			<link rel="canonical" href="★ページのURL（https://biryuhyakkaweb.jp/feature/cosmecalendar/）" />
			<meta property="og:locale" content="ja_JP" />
			<meta property="og:title" content="★ページのタイトル" />
			<meta property="og:type" content="website" />
			<meta property="og:url" content="★ページのURL（https://biryuhyakkaweb.jp/feature/cosmecalendar/）" />
			<meta property="og:description" content="★ページの説明" />
			<meta property="og:site_name" content="美流百華WEB" />
			<meta name="twitter:site" content="@sogoseibu_kuma" />
			<meta name="twitter:card" content="★ページのサムネイル画像URL" />
			<meta name="twitter:title" content="★ページのタイトル" />
			<meta name="twitter:creator" content="@sogoseibu_kuma" />
			<meta name="twitter:domain" content="biryuhyakkaweb.jp" />
			<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />

			<script type="text/javascript" async="" src="https://www.google-analytics.com/analytics.js"></script>
			<script src="https://connect.facebook.net/ja_JP/sdk.js?hash=f38ae05300fc2626584ead0d216f7c27" async="" crossorigin="anonymous"></script>
			<script type="text/javascript" async="" src="https://www.googletagmanager.com/gtag/js?id=UA-114097259-6&amp;l=dataLayer&amp;cx=c"></script>
			<script id="facebook-jssdk" src="https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&amp;version=v3.0"></script><script id="twitter-wjs" src="http://platform.twitter.com/widgets.js"></script>
			<script async="" src="//www.google-analytics.com/analytics.js"></script>
			<script src="https://biryuhyakkaweb.jp/assets/article_first_lib-cb49f017909773631805af9911644df9d9244b9282f0fdd27b3d4f4221465c51.js"></script>
			<script src="https://biryuhyakkaweb.jp/assets/application-e6f5d9c11bf9df5bfcbb7b287a6338128f8288bc89c543a04a292c49edbdb1c4.js" defer="defer"></script>

			<link rel="stylesheet" media="all" href="https://biryuhyakkaweb.jp/assets/application-06bf7e3c6a73f4b75c79e35e9b8ddcd5f9e92a3adc30a4afe35d222025a6834e.css" />
			<link rel="shortcut icon" type="image/x-icon" href="/uploads/app_setting/favicon/1/5bb29909-0fe3-41db-aa2a-ffd635e80594.png" />
			<link rel="apple-touch-icon" type="image/png" href="/uploads/app_setting/touch_icon/1/3c3af10e-dd2d-4ef3-ab39-95ccaa9f525e.png" />
			<link rel="stylesheet" media="screen" href="/styles/index.css" />
		</Helmet>} */}

		{/* {conf["header"]} */}
		{/* 開発用CSSの読み込み */}
		{sscss}
		{/* コスメカレンダー専用CSS */}
		<link rel="stylesheet" type="text/css" href={pgstyle} media="all" />

		<App dev={dev} conf={conf} />

		<div className="txtinfo">
			<p>※販売終了や価格改定などによるサイトメンテナンスで一部商品の表示がされない場合がございます。あらかじめご了承ください。</p>
		</div>
		{/* {conf["footer"]} */}
	</div>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
